import { CFDIStampBalance as componentsCFDIStanpBalances } from "./CFDIStampBalances";

export const CFDIStampBalance = componentsCFDIStanpBalances;

